import React from "react";

const Tab = ({title, activeTab, setActiveTab, index}) => {

  return (
    <div className={`large-2 medium-2 small-12 columns tab text-center end ` + (title === activeTab ? 'active' : '') + (index === 0 ? ' large-offset-3' : '')} onClick={() =>  setActiveTab(title)}>
      {title}
    </div>
  )
}

export default Tab;